import { useEffect } from "react";

import landing from "config/i18n/landing";
import { resolveLang } from "hooks/useLang";

/** Default title in the site language, e.g. "… – Marktsimulation · MS Trader · JAMA". */
export const defaultTitle = (): string =>
  `MARKSIM Services GmbH – ${landing[resolveLang()].nav.marksim} · MS Trader · JAMA`;

/** Sets document.title for the current page; restores the default on unmount. */
const usePageTitle = (title?: string) => {
  useEffect(() => {
    document.title = title ? `${title} · MARKSIM` : defaultTitle();
    return () => {
      document.title = defaultTitle();
    };
  }, [title]);
};

export default usePageTitle;
